export enum EDimensionKey {
  TIME = 'time',
  EXPERIMENT_ID = 'experiment_id',
  VERSION = 'version',
  VISITOR = 'visitor_type',
  TRAFFIC_SOURCE = 'traffic_source',
  DEVICE = 'device',
}
